module.exports = __webpack_public_path__ + "media/images/icons/icon-top-areas-served-3431d7cc39f56edf255f1927ea1692b4.svg";